import { InjectionToken, Provider, Type } from '@angular/core';
import {
  AutomationActionType,
  AutomationContext,
  AutomationRuleType,
} from '@kinet-open-network/shared/data-access/model';
import { ActionComponent } from './automation-actions/actions/abstract-action.component';
import { RuleComponent } from './automation-conditions/rules/abstract-rule.component';
import { IFieldChangeFieldDef } from './field-change-trigger/rules/field-change-context-fields';

export interface AutomationBuilderConfig {
  actions?: Partial<Record<AutomationActionType, Type<ActionComponent<any>>>>;
  conditions?: Partial<Record<AutomationRuleType, Type<RuleComponent>>>;
  fieldChangeContextFields?: Partial<
    Record<AutomationContext, IFieldChangeFieldDef[]>
  >;
}

export const AUTOMATION_BUILDER_CONFIG =
  new InjectionToken<AutomationBuilderConfig>('AUTOMATION_BUILDER_CONFIG');

export function provideAutomationBuilderConfig(
  config: AutomationBuilderConfig,
): Provider {
  return {
    provide: AUTOMATION_BUILDER_CONFIG,
    useValue: config,
  };
}
